import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralizeWithCount } from "@common/helpers/string";

interface Props {
    filters: Pick<FiltersTypes, "invoiceIds">;
}

export const InvoiceIdsFilterLabel: React.FC<Props> = ({ filters }) => {
    const invoiceIds = filters.invoiceIds;

    if (!invoiceIds || invoiceIds.length === 0) {
        return null;
    }

    return <>{pluralizeWithCount("invoice", invoiceIds.length)}</>;
};
